import React from 'react'

import { IconMute } from '../../../../icons/IconMute/IconMute'
import {
    StyledUnmuteButton,
    StyledUnmuteButtonProps,
} from '../../../../content/Video/components/UnmuteButton/UnmuteButton.styled'
import { cx } from '@emotion/css'

export const UnmuteButton: React.FC<StyledUnmuteButtonProps> = (props) => {
    const isCrushed = props.positionState && props.positionState.alignToTop
    const isLowered =
        props.positionState && props.positionState.isLowered && !isCrushed

    return (
        <StyledUnmuteButton
            className={cx({ isCrushed, isLowered })}
            onClick={props.action}
            type="button"
        >
            <IconMute /> Click to unmute
        </StyledUnmuteButton>
    )
}
